import React from 'react';
import { ShieldAlert } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';

export default function PermissionDeniedCard({ message, title = 'Accesso negato', className = '' }) {
  return (
    <Card className={`max-w-md w-full text-center border border-red-200 bg-red-50 ${className}`.trim()}>
      <CardHeader>
        <div className="flex justify-center mb-2">
          <ShieldAlert className="h-10 w-10 text-red-600" />
        </div>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-red-700">{message}</p>
      </CardContent>
    </Card>
  );
}
